import store from '@/src/server/plugins/store'

// iFrameResizer property MUST be defined before require iframe-resizer library
const messageCallbacks = {
  url ({ url }) {
    if (!store.clientUrl) {
      store.clientUrl = url
    }
  },
}

const sendMessage = (type, message = {}) => {
  message.type = type
  if ('parentIFrame' in window) {
    window.parentIFrame.sendMessage(JSON.stringify(message))
  }
}

window.iFrameResizer = {
  readyCallback () {
    sendMessage('ready')
  },

  messageCallback (message) {
    message = JSON.parse(message)
    if (message.type in messageCallbacks) {
      messageCallbacks[message.type](message)
    }
  },
}

require('iframe-resizer/js/iframeResizer.contentWindow')



// WEBPACK FOOTER //
// ./src/server/plugins/iframe-resizer.js